<template>
  <span
      class="task-status-tag"
      :class="['task-status--' + statusKey, sizeClass, customClass]"
      :style="customStyle"
  >
    {{ statusText }}
  </span>
</template>

<script>
export default {
  name: 'TaskStatus',
  props: {
    // 状态值（支持code数字 或 枚举key字符串）
    status: {
      type: [Number, String],
      required: true
    },
    // 尺寸：small / medium / large
    size: {
      type: String,
      default: 'medium',
      validator: function(v) {
        return ['small', 'medium', 'large'].includes(v);
      }
    },
    // 自定义类名
    customClass: {
      type: String,
      default: ''
    },
    // 自定义样式
    customStyle: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      // 状态枚举映射（只定义一次）
      STATUS_MAP: {
        DRAFT: { code: 0, text: '草稿', type: 'default' },
        WAIT_AUDIT: { code: 10, text: '待审核', type: 'info' },
        AUDIT_PASS: { code: 11, text: '审核通过', type: 'success' },
        AUDIT_NOT_PASS: { code: 12, text: '审核未通过', type: 'danger' },
        WAIT_PUBLISH: { code: 13, text: '待发布', type: 'info' },
        WAIT_START: { code: 20, text: '待报名', type: 'info' },
        REGISTER_START: { code: 21, text: '报名中', type: 'primary' },
        SURE_SERVICER: { code: 22, text: '确定服务商中', type: 'primary' },
        UPLOAD_CONTRACT: { code: 30, text: '上传合同中', type: 'primary' },
        IMPLEMENT: { code: 40, text: '实施中', type: 'primary' },
        ACCEPTANCE: { code: 50, text: '验收中', type: 'primary' },
        PAY: { code: 60, text: '待支付', type: 'warning' },
        COMPLETE: { code: 90, text: '完成', type: 'success' },
        CANCEL: { code: 99, text: '任务关闭', type: 'danger' }
      }
    };
  },
  computed: {
    // 计算状态key（统一转为枚举key）
    statusKey() {
      const { status } = this;
      // 如果是数字，反向查找枚举key
      if (typeof status === 'number') {
        return Object.keys(this.STATUS_MAP).find(key => this.STATUS_MAP[key].code === status) || 'DRAFT';
      }
      // 如果是字符串，转大写后使用（修正拼写错误！）
      const upperStatus = status.toUpperCase();
      return this.STATUS_MAP[upperStatus] ? upperStatus : 'DRAFT';
    },
    // 计算状态文本
    statusText() {
      return this.STATUS_MAP[this.statusKey].text;
    },
    // 计算尺寸类名
    sizeClass() {
      return `task-status--${this.size}`;
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.task-status-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s ease;
}

/* 尺寸样式 */
.task-status--small {
  padding: 2px 8px;
  font-size: 12px;
  height: 20px;
}

.task-status--medium {
  padding: 3px 12px;
  font-size: 13px;
  height: 24px;
}

.task-status--large {
  padding: 4px 16px;
  font-size: 14px;
  height: 28px;
}

/* 状态类型样式 */
/* 默认/草稿 */
.task-status--DRAFT {
  background-color: #f5f7fa;
  color: #909399;
  border: 1px solid #e5e6eb;
}

/* 信息类（待审核/待发布/待报名） */
.task-status--WAIT_AUDIT,
.task-status--WAIT_PUBLISH,
.task-status--WAIT_START {
  background-color: #ecf5ff;
  color: #409eff;
  border: 1px solid #b3d8ff;
}

/* 主要操作中 */
.task-status--REGISTER_START,
.task-status--SURE_SERVICER,
.task-status--UPLOAD_CONTRACT,
.task-status--IMPLEMENT,
.task-status--ACCEPTANCE {
  background-color: #f0f9ff;
  color: #0ea5e9;
  border: 1px solid #bae6fd;
}

/* 成功类（审核通过/完成） */
.task-status--AUDIT_PASS,
.task-status--COMPLETE {
  background-color: #f0fdf4;
  color: #10b981;
  border: 1px solid #bbf7d0;
}

/* 警告类（待支付）- 修复文字颜色 */
.task-status--PAY {
  background-color: #fffbeb;
  color: #f59e0b;
  border: 1px solid #fed7aa;
}

/* 危险类（审核未通过/任务关闭） */
.task-status--AUDIT_NOT_PASS,
.task-status--CANCEL {
  background-color: #fef2f2;
  color: #ef4444;
  border: 1px solid #fecdd3;
}

/* hover效果 */
.task-status-tag:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
</style>